import { useState } from "react";
import { STANDARD, TIERS, monthlyAt, usd } from "./data";

export const GtaxCalculator = () => {
  const [amt, setAmt] = useState(100000);
  const rows = [STANDARD, ...TIERS].map((t) => ({ ...t, ok: amt >= t.min }));
  return (
    <section className="py-32 gx-ivory" data-testid="gtax-calculator">
      <div className="gx-wrap grid lg:grid-cols-2 gap-16">
        <div>
          <p className="gx-eyebrow">Your share</p>
          <h2 className="gx-serif text-4xl md:text-5xl mt-6">Illustrate your monthly share.</h2>
          <p className="mt-6 text-[color:var(--mute)] max-w-md">Hypothetical illustration at a 0.80% average realised gross result per trading day, 22 trading days a month, net of all strategy, execution and introducer costs. Not a forecast or a promise.</p>
          <label className="block mt-12 text-xs tracking-widest uppercase text-[color:var(--mute)]">Investment (USD)</label>
          <input type="number" min={1000} step={1000} value={amt} onChange={(e) => setAmt(Number(e.target.value) || 0)}
            className="gx-serif text-5xl w-full py-3 mt-2" data-testid="gtax-calc-input" />
        </div>
        <div className="gx-card divide-y divide-[color:var(--line)]">
          {rows.map((r) => (
            <div key={r.name} className={`flex items-center justify-between p-7 ${r.ok ? "" : "opacity-35"}`} data-testid={`gtax-calc-row-${r.name.replace(" ", "").toLowerCase()}`}>
              <div>
                <div className="gx-serif text-2xl">{r.name}</div>
                <div className="text-xs text-[color:var(--mute)] mt-1">{r.ok ? "Eligible" : `From ${usd(r.min)}`}</div>
              </div>
              <div className="text-right">
                <div className="gx-serif text-3xl gx-gold">{r.ok ? usd(amt * monthlyAt(r, 0.8)) : "—"}</div>
                <div className="text-xs text-[color:var(--mute)]">per month</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
